import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const influencerStaticData = {
  menuTitle: MenuTitle.Influencers
};
export const Route = createFileRoute('/_private-routes/influencer')({
  staticData: influencerStaticData
});
